import ServiceExec from '@/common/utils/ServiceExec';
import { premium } from '@/common/service/apiList';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

export default {
  getPremiumPointList: async function({ commit, getters, state }, menu) {
    const condition = getters['getCondition'];
    if (condition.page > state.pageInfo.endPage) return;
    const { userNo } = store.getters['user/getUserData'];
    condition.userNo = userNo;
    condition.searchType = menu;
    const { data, status } = await ServiceExec.get(premium.getPremiumPointList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setList', list ?? []);
  },
  getPoint: async ({}) => {
    const { userNo } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(premium.getPoint(userNo));
    if (ServiceExec.status.OK !== status) return false;
    store.commit('user/setUserPoint', data);
    return data;
  }
};
